/**
 * Learning Hub Helpjuice to Docs redirect mappings.
 *
 * This file contains mappings from old Helpjuice article slugs to new docs slugs.
 * These mappings are used to redirect users from old /learn#slug URLs to new /docs/slug URLs.
 *
 * This is legacy redirect code that will stick around long-term to handle old bookmarks
 * and external links pointing to the old Helpjuice-based learning hub.
 */

// Maps old Helpjuice slugs to new docs slugs for redirects.
// This allows redirecting users from old /learn#slug URLs to new /docs/slug URLs.
// Auto-generated mapping from helpjuice slugs to sanity slugs
// Generated on 2025-12-17T19:21:19.197Z
export const HelpjuiceToNewDocsPageSlugMap: Record<string, string> = {
  'getting-started-writing-your-sustainability-statement': 'esrs',
  'sustainable-aviation-fuel-saf-and-safc': 'saf-certificates',
  'carbon-accounting-101': 'carbon-accounting',
  'how-to-upload-a-double-materiality-assessment': 'uploading-dma',
  'how-we-measure-emissions-for-end-of-life-treatment-of-sold-products-scope-312':
    'scope-3-12-end-of-life-treatment-of-sold-products',
  'how-we-measure-emissions-from-business-travel-scope-36':
    'scope-3-6-business-travel',
  'asset-groups': 'asset-groups',
  'csrd-social-metrics-gender-pay-gap-': 'gender-pay-gap',
  'measuring-financed-emissions-in-watershed-finance': 'watershed-finance',
  'reviewing-a-footprint': 'reviewing-and-approving-footprint',
  'how-to-build-a-sb261-report': 'building-sb261-report',
  'fuel-combustion-version-12': 'fuel-combustion-version-12',
  'how-watershed-measures-financed-emissions-from-sovereign-debt':
    'sovereign-debt',
  'biodiversity-for-csrd-': 'biodiversity-for-csrd',
  'supply-chain-using-tasks': 'assigning-tasks',
  'getting-started-in-the-watershed-supplier-portal': 'supplier-portal',
  'understanding-changes-in-your-footprint':
    'analyzing-finance-footprint-changes',
  'types-of-data-in-ghg-accounting': 'data-types-in-ghg-accounting',
  'science-of-the-climate-crisis': 'science-of-the-climate-crisis',
  'how-we-measure-emissions-from-fuel-and-energy-related-activities-scope-33':
    'scope-3-3-fuel-and-energy-related-activities',
  revenue: 'revenue',
  'facilities-electricity-consumption-version-22':
    'facilities-electricity-consumption-version-22',
  waste: 'waste',
  'what-is-activity-data': 'activity-data',
  'how-we-measure-emissions-from-corporate-investments-scope-315':
    'scope-3-15-corporate-investments',
  'electricity-update-october-2024': 'electricity-update-october-2024',
  'network-tasks': 'network-tasks',
  'australia-and-new-zealand-fuel-and-electricity-factors-update':
    'australia-and-new-zealand-fuel-and-electricity-factors-update',
  'overview-physical-goods': 'overview-physical-goods',
  'understanding-g1-business-conduct': 'g1-business-conduct',
  'update-to-methane-gwp-for-fuel-combustion-data':
    'update-to-methane-gwp-for-fuel-combustion-data',
  'vehicle-travel-version-17': 'vehicle-travel-version-17',
  'measuring-financed-emissions-from-equity-corporate-bonds-and-business-loans':
    'equity-corporate-bonds-business-loans',
  'managing-session-timeout-configurations-in-watershed': 'session-timeout',
  'sold-vehicles-version-3': 'sold-vehicles-version-3',
  'refrigerants-update-october-2024': 'refrigerants-update-october-2024',
  'updated-dataset-and-activity-type-names-[oct-2024]':
    'updated-dataset-and-activity-type-names-[oct-2024]',
  'reporting-boundaries-and-csrd': 'reporting-boundaries',
  'building-stationary-combustion-version-16':
    'building-stationary-combustion-version-16',
  'logistics-version-9': 'logistics-version-9',
  'e2-5-substances-of-concern-very-high-concern-':
    'e2-5-substances-of-concern-very-high-concern',
  'how-we-measure-emissions-from-franchises-scope-314': 'scope-3-14-franchises',
  'setting-climate-target': 'setting-climate-targets',
  'employees-version-16': 'employees-version-16',
  'measuring-financed-emissions-from-commercial-real-estate':
    'commercial-real-estate',
  'planning-and-scoping-your-financed-emissions-measurement':
    'planning-and-scoping-finance-measurement',
  'ceda-2024-release-note': 'ceda-2024-release-note',
  'setting-up-your-data-for-the-long-term':
    'setting-up-your-data-for-the-long-term',
  'useeio-version-15': 'useeio-version-15',
  'best-practices-for-reviewing-your-financed-emissions-footprint':
    'reviewing-approving-finance-footprint',
  'ensuring-your-data-relationships-are-accurate':
    'ensuring-your-data-relationships-are-accurate',
  'asset-value-based-estimations': 'pcaf-score-5-estimates',
  'how-to-create-a-reductions-plan': 'creating-a-reductions-plan',
  'tier-1-supplier-factories-spend-version-4':
    'tier-1-supplier-factories-spend-version-4',
  'fuel-combustion-version-13': 'fuel-combustion-version-13',
  'test-article': 'test-article',
  'flags-anomalies-watershed-finance': 'flagging-anomalies-watershed-finance',
  'what-is-an-emissions-trading-scheme-ets': 'emissions-trading-scheme',
  'air-travel-version-14': 'air-travel-version-14',
  'comparative-information-for-the-csrd': 'comparative-information',
  'what-is-cdp': 'cdp',
  'deprecation-notice-cloud-usage-and-expenses-dataset':
    'deprecation-cloud-usage-and-expenses-dataset',
  'non-renewable-and-renewable-energy-production-in-the-esrs':
    'non-renewable-and-renewable-energy-production',
  'tier-1-factories-methodology': 'tier-1-factories-methodology',
  'why-you-might-consider-ceda-for-your-next-measurement': 'ceda',
  'supply-chain-overview': 'supply-chain',
  'rail-dataset': 'rail-travel',
  'understanding-the-eu-taxonomy': 'understanding-the-eu-taxonomy',
  'customizing-employee-commute-assumptions':
    'customizing-employee-commute-assumptions',
  'what-are-contractual-instruments-for-scope-2-emissions':
    'contractual-instruments-for-scope-2-emissions',
  'non-building-electricity-consumption-version-19':
    'non-building-electricity-consumption-version-19',
  'global-temperature-impacts': 'global-temperature-impacts',
  '-understanding-e5-5-waste': 'e5-5-waste',
  'recyclability-of-products-packaging':
    'e-5-5-recyclability-of-products-packaging',
  'measuring-financed-emissions-from-investment-funds':
    'financed-emissions-from-investment-funds',
  'creating-a-footprint-in-watershed-finance':
    'creating-a-footprint-watershed-finance',
  'disclosing-clean-power': 'disclosing-clean-power-credits',
  'how-watershed-measures-financed-emissions-from-project-finance':
    'project-finance',
  'sbt-criteria': 'sbt-criteria',
  'e5-4-resource-inflows': 'e5-4-resource-inflows',
  'guide-creating-a-footprint-bridge-in-excel': 'footprint-bridge',
  'data-collection-quality-watershed-finance':
    'data-collection-quality-watershed-finance',
  'tier-1-supplier-factories-energy-waste-and-water-version-4':
    'tier-1-supplier-factories-energy-waste-and-water-version-4',
  'use-of-sold-products-dataset': 'sold-products-usage',
  'building-occupation-version-18': 'building-occupation-version-18',
  'an-outline-of-the-measurement-process':
    'an-outline-of-the-measurement-process',
  'co-located-data-center-electricity-consumption-version-15':
    'co-located-data-center-electricity-consumption-version-15',
  'finance-metric-calculations': 'metrics-watershed-finance',
  'using-drilldown': 'drilldown',
  'understanding-watersheds-sustainability-database': 'company-database',
  'mandatory-climate-disclosures': 'mandatory-climate-disclosures',
  'electricity-update-march-2025': 'electricity-update-march-2025',
  'how-to-understand-the-impact-of-grid-greening-on-your-footprint':
    'grid-greening-your-footprint',
  'kyoto-gas-breakouts-and-2025-database-updates':
    'kyoto-gas-breakouts-and-2025-database-updates',
  'choosing-emissions-factor-libraries': 'choosing-emissions-factor-libraries',
  'syncing-to-cdp-portal-api': 'syncing-to-cdp-portal-api',
  'rebaselining-and-restatement': 'rebaselining-and-restatement',
  'lifetime-electricity-and-fuel-usage-version-8':
    'lifetime-electricity-and-fuel-usage-version-8',
  'finance-monthly-product-updates': 'finance-monthly-product-updates',
  'using-the-watershed-cdp-report-builder-for-auto-generated-metrics':
    'auto-generated-metrics-cdp',
  'carbon-accounting-methodology-overview': 'methodology-approach',
  'facilities-occupancy-version-21': 'facilities-occupancy-version-21',
  'using-custom-columns': 'custom-columns',
  'rail-methodology': 'rail-methodology',
  'how-to-use-watershed-finances-portfolio-measurement-management-tools':
    'asset-tracking',
  flights: 'commercial-air-travel',
  'air-travel-version-15': 'air-travel-version-15',
  'methodology-and-audit-trails-for-esg-data-in-csrd':
    'methodology-and-audit-trails-for-esg-data',
  'organizational-structure': 'organizational-structure',
  'corporate-investments-version-2': 'corporate-investments-version-2',
  'cloud-methodology': 'cloud-methodology',
  'vehicles-methodology': 'vehicles-methodology',
  'operating-expenses': 'operating-expenses',
  'uploading-custom-activities': 'uploading-custom-activity-data',
  'ai-drafts-in-california-sb-261': 'ai-drafts',
  'ceda-2024-frequently-asked-questions':
    'ceda-2024-frequently-asked-questions',
  'how-we-approach-supplier-specific-emissions-factors':
    'supplier-specific-emissions-factors',
  'estimating-direct-emissions-due-to-enteric-fermentation':
    'enteric-fermentation',
  'unpacking-california-climate-disclosures': 'california-climate-disclosures',
  'how-to-use-approval-workflows': 'data-approvals',
  'water-metric-kinds': 'water',
  'quick-start-guide': 'quick-start-guide',
  'product-updates': 'product-updates',
  'coverage-ratios-best-practices-for-watershed-finance':
    'coverage-ratios-watershed-finance',
  'corporate-investments-methodology': 'corporate-investments-methodology',
  'what-are-financed-emissions': 'financed-emissions',
  'policy-updates': 'policy-updates-archived',
  'ceda-2025-faqs': 'ceda-2025-faqs',
  'flag-emissions-101': 'flag',
  'eu-data-residency': 'eu-data-residency',
  'measuring-physical-product-emissions':
    'measuring-physical-product-emissions',
  'understanding-watersheds-company-estimation-engine':
    'company-estimation-engine',
  'how-we-measure-purchased-energy-emissions-scope-2':
    'scope-2-purchased-energy-emissions',
  'understanding-emission-factors': 'understanding-emission-factors',
  'how-we-choose-methodology-assumptions': 'methodology-assumptions',
  'lodging-methodology': 'lodging-methodology',
  'how-we-measure-colocated-data-center-emissions': 'colocated-data-center',
  'choosing-pcaf-asset-classes': 'choosing-pcaf-asset-classes',
  'expenditures-methodology': 'expenditures-methodology',
  'building-stationary-combustion-methodology':
    'facilities-stationary-combustion-methodology',
  'ceda-flag-version-3': 'ceda-flag-version-3',
  'csrd-deep-dive': 'csrd',
  'how-to-create-custom-metrics': 'custom-metrics',
  'for-verifiers-navigating-watershed-during-verification':
    'for-verifiers-navigating-watershed-during-verification',
  'writing-qualitative-disclosures-for-the-csrd':
    'writing-qualitative-disclosures',
  'eeios-ceda-useeio': 'ceda-and-useeio',
  'how-we-account-for-packaging-waste': 'packaging-waste',
  'financial-mapping': 'financial-mapping',
  'carbon-methodology-updates': 'methodology-updates',
  'sold-fuels-methodology': 'sold-fuels-methodology',
  'creating-and-configuring-your-csrd-report':
    'creating-and-configuring-your-csrd-report',
  'ceda-flag-version-4': 'ceda-flag-version-4',
  's1-own-workforce-definitions-and-methodologies': 's1-own-workforce',
  'best-practices-for-reviewing-facilities-utilities-data-':
    'best-practices-for-reviewing-facilities-utilities-data-',
  'getting-started-with-measurement': 'getting-started-with-measurement',
  'supplier-targets-and-emissions-in-reductions':
    'supplier-targets-and-emissions',
  'roles-and-permissions': 'roles-and-permissions',
  'vehicle-travel-version-20': 'vehicle-travel-version-20',
  'refrigerants-version-20': 'refrigerants-version-20',
  'full-list-of-bea-codes': 'bea-codes',
  'measurement-configuration': 'measurement-configuration',
  'how-we-measure-emissions-from-downstream-leased-assets-scope-313':
    'scope-3-13-downstream-leased-assets',
  'electricity-consumption-version-20': 'electricity-consumption-version-20',
  'employees-methodology': 'employees-methodology',
  'hotels-dataset-': 'lodging-dataset',
  'injecting-primary-data-into-your-measurement':
    'injecting-primary-data-into-your-measurement',
  'ceda-version-7-useeio-version-16': 'ceda-version-7-useeio-version-16',
  'planning-your-measurement': 'measurement-scoping',
  'database-updates-for-epa-ef-hub-and-egrid':
    'database-update-for-epa-ef-hub-and-egrid',
  'fuel-combustion-version-11': 'fuel-combustion-version-11',
  'how-do-we-account-for-food-waste': 'food-waste',
  'how-to-upload-data': 'uploading-data',
  'purchased-materials-methodology': 'purchased-materials-methodology',
  'ceda-changelog': 'ceda-changelog',
  'uploading-an-existing-footprint': 'uploading-an-existing-footprint',
  'ceda-2025-release-notes': 'ceda-2025-release-notes',
  'data-lineage': 'data-lineage',
  'how-to-create-a-footprint': 'creating-a-footprint',
  'configuring-the-supplier-engagement-module': 'configuring-Supply-Chain',
  'sold-products-methodology': 'sold-products-methodology',
  'understanding-verifications': 'verifications',
  'how-to-recategorize-your-footprint': 'recategorization-rules',
  'how-to-use-watershed-finances-tasks-flow': 'tasks-flow',
  'csrd-report-builder-updates': 'csrd-report-builder-updates',
  'how-we-measure-emissions-from-waste-scope-35': 'scope-3-5-waste',
  'critical-decade-for-climate-action': 'climate-action-timeline',
  'ai-suggestions-in-california-sb261': 'ai-suggestions',
  'carbon-removal-criteria': 'carbon-removal-criteria',
  'changing-language-locale-on-watershed': 'locale-settings',
  'vppa-overview': 'vppa',
  'how-to-understand-calculation-updates-for-your-footprint':
    'calculation-method-updates',
  'selecting-a-purpose-for-your-buildings-fuel-combustion':
    'selecting-a-purpose-for-your-buildings-fuel-combustion',
  api: 'api',
  'how-we-measure-emissions-from-upstream-leased-assets-scope-38':
    'scope-3-8-upstream-leased-assets',
  'building-electricity-methodology': 'building-electricity-methodology',
  'how-to-configure-sso-firewall': 'it-settings',
  'how-we-measure-emissions-from-purchased-goods-and-services-scope-31':
    'scope-3-1-purchased-goods-and-services',
  'ghg-categorization-of-our-methodologies': 'methodologies-by-ghg-scopes',
  'how-we-measure-direct-emissions-scope-1': 'scope-1-direct-emissions',
  'measuring-clean-power-usage-on-building-utilities':
    'clean-power-in-facilities-and-utilities',
  'facilities-utilities-datasets': 'facilities-utilities',
  'configuring-e3-measurement': 'configuring-e3-measurement',
  'clean-power-overview': 'clean-power',
  'use-of-artificial-intelligence-ai': 'artificial-intelligence',
  'gapfilling-data': 'gapfilling-data',
  'what-is-non-emissive-spend-': 'non-emissive-spend',
  'setting-up-a-csrd-measurement': 'setting-up-a-csrd-measurement',
  vehicles: 'vehicles',
  'co-located-data-center-electricity-consumption-version-14':
    'co-located-data-center-electricity-consumption-version-14',
  'refrigerants-version-21': 'refrigerants-version-21',
  'cloud-spend-based-emission-factor-methodology':
    'cloud-spend-based-emission-factor-methodology',
  'applying-clean-power-to-different-scopes-of-your-footprint':
    'clean-power-scopes',
  logistics: 'logistics',
  'using-benchmarks': 'benchmarks',
  'how-to-map-food-items': 'mapping-food-items',
  'how-to-create-custom-maturity-scoring': 'custom-maturity-scoring',
  'cloud-usage-version-13': 'cloud-usage-version-13',
  'how-we-measure-emissions-from-use-of-sold-products-scope-311':
    'scope-3-11-sold-products',
  food: 'food',
  'supplier-mapping': 'mapping-suppliers',
  'food-methodology': 'food-methodology',
  'how-we-measure-emissions-from-upstream-transportation-and-distribution-scope-34':
    'scope-3-4-upstream-transportation-and-distribution',
  'watershed-product-footprints': 'product-footprints',
  cloud: 'cloud',
  'refrigerants-methodology': 'refrigerants-methodology',
  'what-is-gwp': 'gwp',
  'facilities-stationary-combustion-version-18':
    'facilities-stationary-combustion-version-18',
  'private-jet-travel-version-9': 'private-jet-travel-version-9',
  'carbon-avoidance-credits': 'carbon-avoidance-credits',
  'decarbonize-apparel-and-footwear': 'decarbonizing-apparel-and-footwear',
  'sold-buildings-methodology': 'sold-buildings-methodology',
  'configuring-e4-measurement': 'configuring-e4-measurement',
  'ceda-version-6': 'ceda-version-6',
  'creating-a-cdp-2025-report': 'creating-a-cdp-2025-report',
  'waste-version-7-facilities-waste-version-18':
    'waste-version-7-facilities-waste-version-18',
  'how-we-measure-emissions-from-employee-commuting-scope-37':
    'scope-3-7-employee-commuting',
  'audit-log': 'audit-log',
  'understanding-climate-risk': 'understanding-climate-risk',
  'e3-4-total-water-consumption-in-areas-of-high-water-stress-':
    'e3-4-total-water-consumption-in-areas-of-high-water-stress',
  'material-assessment-version-4': 'material-assessment-version-4',
  'safc-procurement': 'saf',
  'employee-commute-update-october-2024':
    'employee-commute-update-october-2024',
  '[beta]-breaking-down-of-your-footprint-by-individual-gases':
    'individual-gas-emissions',
  'flights-methodology': 'flights-methodology',
  'choosing-your-pcf-boundaries-and-how-to-implement-in-watershed':
    'choosing-your-pcf-boundaries-and-how-to-implement-in-watershed',
  'preparing-for-secr': 'build-a-secr-report',
  'uploading-data-for-watershed-finance': 'uploading-data-watershed-finance',
  'how-to-prepare-your-financial-data-for-mapping': 'preparing-financial-data',
  'pcaf-scoring': 'pcaf-scoring',
  'how-to-deduplicate-your-footprint': 'exclusion-rules',
  employees: 'employees',
  'logistics-methodology': 'logistics-methodology',
  'company-mapping-watershed-finance': 'company-mapping-watershed-finance',
  'useeio-2024-and-iea-2025-update': 'useeio-2024-and-iea-2025-update',
  'qualitative-approval-workflows': 'qualitative-approval-workflows',
  issb: 'issb',
  'waste-methodology': 'waste-methodology',
  cee: 'company-estimates-watershed-finance',
  'supported-product-categories': 'supported-product-categories',
  'employees-version-14': 'employees-version-14',
  'facilities-stationary-combustion-version-17':
    'facilities-stationary-combustion-version-17',
  'electricity-consumption-version-21': 'electricity-consumption-version-21',
  'employees-version-15': 'employees-version-15',
  'cloud-usage-version-11': 'cloud-usage-version-11',
  'how-watershed-measures-insurance-associated-emissions-from-personal-motor-vehicle-policies':
    'personal-motor-vehicles-insurance',
  'electricity-patches-march-2025-copy-921':
    'electricity-patches-march-2025-copy-921',
  'minimum-disclosure-requirements-for-metrics-mdr-m-e1-climate-change':
    'minimum-disclosure-requirements-for-metrics-e1',
  'double-materiality-assessments-under-csrd': 'double-materiality',
  'vehicles-version-16': 'vehicles-version-16',
  '[beta]drilldown': 'drilldown-beta',
  'how-watershed-measures-insurance-associated-emissions-commercial-lines':
    'insurance-associated-emissions',
  'configuring-e5-measurement': 'configuring-e5-measurement',
  'facilities-and-employee-wfh-utility-estimates-update':
    'facilities-and-employee-wfh-utility-estimates-update',
  'estimating-direct-emissions-due-to-fertilizer-application':
    'fertilizer-application',
  'custom-activity': 'custom-activity',
  'sold-retail-goods-version-7': 'sold-retail-goods-version-7',
  'technical-specifications-for-clean-power-':
    'clean-power-technical-specifications',
  'reductions-overview': 'reductions',
  'facilities-occupancy-version-19': 'facilities-occupancy-version-19',
  'tier-1-factories-spend-version-3': 'tier-1-factories-spend-version-3',
  'textile-product-use-phase-version-4': 'textile-product-use-phase-version-4',
  'electricity-patches-march-2025': 'electricity-patches-march-2025',
  'lifetime-electricity-and-fuel-usage-version-9':
    'lifetime-electricity-and-fuel-usage-version-9',
  'sold-vehicles-version-5': 'sold-vehicles-version-5',
  'facilities-electricity-consumption-version-21':
    'facilities-electricity-consumption-version-21',
  'fuels-update-october-2024': 'fuels-update-october-2024',
  'lifetime-electricity-and-fuel-usage-version-10':
    'lifetime-electricity-and-fuel-usage-version-10',
  'employees-version-13': 'employees-version-13',
  'building-electricity-consumption-version-20':
    'building-electricity-consumption-version-20',
  'tier-1-factories-activity-data-version-3':
    'tier-1-factories-activity-data-version-3',
  'facilities-occupancy-version-20': 'facilities-occupancy-version-20',
  'data-transfer-version-3': 'data-transfer-version-3',
  'ceda-version-5-useeio-version-14': 'ceda-version-5-useeio-version-14',
  'cloud-usage-version-12': 'cloud-usage-version-12',
  'vehicle-travel-version-18': 'vehicle-travel-version-18',
  'uploading-location-data': 'uploading-location-data',
  'cloud-spend-version-13': 'cloud-spend-version-13',
  'rail-travel-version-6': 'rail-travel-version-6',
  'vehicle-travel-version-19': 'vehicle-travel-version-19',
  'carbon-removal-approaches': 'carbon-removal',
  'data-size-limits': 'data-size-limits',
  'introduction-to-watershed-finance-verification-features':
    'verification-watershed-finance',
  'e1-7-ghg-removals-and-ghg-mitigation-projects-financed-through-carbon-credits':
    'e1-7-ghg-removals-and-carbon-credits',
  'scopes-of-emissions': 'scopes-of-emissions',
  'e2-4-–-emissions-to-air-': 'e2-4-emissions-to-air-water-soil',
  'e2-4-microplastics-': 'e2-4-microplastics',
  'employees-version-12': 'employees-version-12',
  'capital-expenses': 'capital-expenses',
  'how-to-set-up-an-integration': 'integrations',
  'reducing-supply-chain-emissions-and-how-to-engage-your-suppliers-':
    'engaging-your-suppliers',
  'how-to-replace-a-quantitive-metric-with-a-text-answer':
    'how-to-replace-a-quantitive-metric-with-a-text-answer',
  'how-we-measure-emissions-from-capital-goods-scope-32':
    'scope-3-2-capital-goods',
  'how-we-measure-emissions-from-downstream-transportation-and-distribution-scope-39':
    'scope-3-9-downstream-transportation-and-distribution',
  'anomaly-detection': 'anomaly-detection',
  'sold-vehicles-methodology': 'sold-vehicles-methodology',
  'sold-retail-goods-version-6': 'sold-retail-goods-version-6',
  'sold-refrigerants-methodology': 'sold-refrigerants-methodology',
  users: 'users',
  'where-should-i-start-with-voluntary-reporting': 'voluntary-reporting',
  'cedaflag-version-2': 'cedaflag-version-2',
  'build-a-report': 'build-a-report',
  'legacy-data': 'legacy-data',
  'technical-specifications-of-watershed-supply-chain':
    'supply-chain-technical-specifications',
  'cloud-usage-and-spend-version-1': 'cloud-usage-and-spend-version-1',
  'using-support': 'contact-support',
  'using-finance-custom-reports': 'finance-custom-reports',
  'watershed-glossary': 'watershed-glossary',
  'science-based-targets': 'science-based-targets',
  'what-is-the-greenhouse-gas-reporting-protocol':
    'greenhouse-gas-reporting-protocol',
  'sold-refrigerants-version-4': 'sold-refrigerants-version-4',
  'sec-climate-disclosure-rule': 'sec-climate-disclosure-rule',
  'how-to-map-materials': 'mapping-product-materials',
  'understanding-secr': 'secr',
  'joining-files-for-pcfs': 'joining-files-for-pcfs',
  'travel-expenses': 'travel-expenses',
  'high-climate-impact-sectors-': 'high-climate-impact-sectors',
  'e1-8-internal-carbon-pricing': 'e1-8-internal-carbon-pricing',
  'reduce-emissions-overview': 'reducing-emissions',
  'sold-vehicles-version-4': 'sold-vehicles-version-4',
  'e1-4-targets': 'e1-4-targets',
  'how-to-map-product-materials': 'mapping-packaging-materials',
  'using-data-explorer': 'finance-data-explorer',
  'fuel-types-and-units-we-support': 'fuel',
  'tcfd-deep-dive': 'tcfd',
  'excluding-optional-categories-from-reductions':
    'excluding-optional-categories',
  'what-is-net-revenue': 'net-revenue',
  'guide-to-cdp-scoring': 'cdp-scoring',
  'ceda-flag-version-5': 'ceda-flag-version-5',
  'custom-columns-watershed-finance': 'custom-columns-watershed-finance',
  'using-ceda-in-watershed-finance': 'ceda-watershed-finance',
  'data-center-electricity-usage-version-13':
    'data-center-electricity-usage-version-13',
  'how-to-measure-fugitive-and-process-gas-emissions': 'direct-ghg-emissions',
  'how-does-the-csrd-define-a-policy': 'defining-csrd-policies',
  'early-csrd-reports-key-learnings-and-implications':
    'early-csrd-reports-key-learnings-and-implications',
  'reporting-permissions': 'reporting-permissions',
  'how-to-measure-physical-goods': 'physical-goods',
  'e1-5-energy-consumption-mix-': 'e1-5-energy-consumption-mix',
  'what-is-gri': 'gri',
  'how-to-use-mapping-tool': 'how-to-use-mapping-tool',
  'how-to-use-multiple-footprints-november-2024': 'multiple-footprints',
  'citation-renewables-wtt-well-to-tank': 'renewables-wtt',
  'what-is-carbon-removal': 'what-is-carbon-removal',

  // Articles linked in product with manual overrides
  'data-collection': 'uploading-data#h-2-collecting-data',
  'data-collection-faqs': 'uploading-data#h-2-collecting-data',
  'how-to-approve-data-for-use-in-footprint-calculations': 'data-approvals',
  'how-to-upload-your-facilities-buildings-and-utilities-data':
    'facilities-utilities',
  'how-to-upload-your-facilities-buildings-and-utilities-data#how-we-gap-fill-your-facilities-data-3':
    'facilities-utilities#h-frequently-asked-questions',
  'introduction-to-watershed-finances-methodology-updates':
    'methodology-updates',
  'reviewing-a-footprint%23requesting-a-watershed-review-1':
    'reviewing-and-approving-footprint#h-footprint-review',
  'completing-your-watershed-footprint': 'reviewing-and-approving-footprint',
  'validating-and-correcting-data-errors':
    'uploading-data#h-3-validating-and-correcting-data',
  'footprint/[beta]-new-data-lineage': 'data-lineage',
  'getting-started-with-measurement#setting-up-your-measurement-2':
    'getting-started-with-measurement',
  'how-does-pcaf-scoring-work': 'pcaf-scoring',
  'financed-emissions': 'financed-emissions',
  'climate-target-setting': 'setting-climate-targets',
  'cee#required-inputs-3':
    'company-estimates-watershed-finance#h-required-inputs',
  'build-a-report#create-custom-reports-2':
    'build-a-report#h-create-custom-reports',
  'understanding-watershed-permissions%23footprints-7':
    'roles-and-permissions#h-all-footprints',
  '[beta]-how-to-use-multiple-footprints-november-2024': 'multiple-footprints',
};

export const HelpjuiceToNewDocsCategorySlugMap: Record<string, string> = {
  'customize-emissions-factors': 'calculation',
  'reporting-and-regulations': 'reporting-and-regulations',
};

/**
 * Extracts the article slug from a hash that may contain paths and heading anchors.
 * Examples:
 * - "article-name" -> "article-name"
 * - "category/subcat/article-name" -> "article-name"
 * - "article-name%23heading" -> "article-name"
 * - "article-name#heading" -> "article-name"
 * - "category/article%23heading" -> "article"
 * - "category/article#heading" -> "article"
 *
 * @param hash - The URL hash value (without the leading #)
 * @returns The extracted article slug, or the original hash if extraction fails
 */
export function extractArticleSlugFromHash(hash: string): string {
  const lastSegment = hash.split('/').pop();
  // Strip both literal # and URL-encoded %23 anchors
  const withoutEncodedAnchor = lastSegment ? lastSegment.split('%23')[0] : hash;
  const articleSlug = withoutEncodedAnchor.split('#')[0];

  // Validate slug format: alphanumeric characters, hyphens, underscores, and brackets
  // This prevents unexpected behavior from malformed or malicious inputs
  const isValidSlug = /^[a-zA-Z0-9\-_[\]]+$/.test(articleSlug);

  return isValidSlug && articleSlug.length > 0 ? articleSlug : hash;
}

/**
 * Result of looking up a redirect URL for a Helpjuice hash.
 */
export type DocsRedirectResult =
  | { type: 'page'; slug: string; anchor?: string }
  | { type: 'category'; slug: string }
  | { type: 'search'; query: string }
  | { type: 'home' };

/**
 * Determines the appropriate docs redirect for a Helpjuice URL hash.
 *
 * The lookup follows this priority:
 * 1. Exact match of full hash (including %23 encoded anchors)
 * 2. Extract article slug and look up page/category
 * 3. If slug > 2 chars, redirect to search
 * 4. Otherwise redirect to docs home
 *
 * @param hash - The URL hash from /learn#hash (without the leading #)
 * @returns A DocsRedirectResult indicating where to redirect
 */
export function getDocsRedirectForHelpjuiceHash(
  hash: string
): DocsRedirectResult {
  // First check if the full hash (including any %23 anchors) matches a map entry
  // This handles special cases like 'understanding-watershed-permissions%23footprints-7'
  let newSlug = HelpjuiceToNewDocsPageSlugMap[hash];
  let categorySlug = HelpjuiceToNewDocsCategorySlugMap[hash];

  if (newSlug) {
    // Handle slugs with anchor fragments (e.g., 'uploading-data#h-2-collecting-data')
    const [slug, anchor] = newSlug.split('#');
    return { type: 'page', slug, anchor };
  }

  if (categorySlug) {
    return { type: 'category', slug: categorySlug };
  }

  // If no exact match, extract the article slug (stripping path and anchor)
  const articleSlug = extractArticleSlugFromHash(hash);
  newSlug = HelpjuiceToNewDocsPageSlugMap[articleSlug];
  categorySlug = HelpjuiceToNewDocsCategorySlugMap[articleSlug];

  if (newSlug) {
    const [slug, anchor] = newSlug.split('#');
    return { type: 'page', slug, anchor };
  }

  if (categorySlug) {
    return { type: 'category', slug: categorySlug };
  }

  // No match found - redirect to search or home
  if (articleSlug.length > 2) {
    return { type: 'search', query: articleSlug.replaceAll('-', ' ') };
  }

  return { type: 'home' };
}
